



































import Vue from "vue";
import { ILS_SITE_NAME, ILS_COPYRIGHT_YEAR } from "../../constants";

export default Vue.extend({
  name: "FooterBottomMenu",
  data() {
    return {
      siteName: ILS_SITE_NAME,
      copyrightYear: ILS_COPYRIGHT_YEAR
    };
  }
});
